// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-checkbox[data-v-0822c5ec] {\n  margin: 0 5px;\n}\n", ""]);
// Exports
module.exports = exports;
